const CarrierIcon = ({
  width=32,
  height=32,
  uniqueId,
  color,
  radiosColor1,
  radiosColor2,
}) => {
  return (
    <svg width={width} height={height} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle r="16" transform="matrix(1 -8.74228e-08 -8.74228e-08 -1 16 16)" fill={`url(#${uniqueId})`} />
      <circle r="14" transform="matrix(1 -8.74228e-08 -8.74228e-08 -1 16 16)" fill="white"/>
      <path d="M20.9998 13.3333H19.3332V12C19.3332 11.2666 18.7332 10.6666 17.9998 10.6666H9.99984C9.2665 10.6666 8.6665 11.2666 8.6665 12V18C8.6665 18.7333 9.2665 19.3333 9.99984 19.3333C9.99984 20.44 10.8932 21.3333 11.9998 21.3333C13.1065 21.3333 13.9998 20.44 13.9998 19.3333H17.9998C17.9998 20.44 18.8932 21.3333 19.9998 21.3333C21.1065 21.3333 21.9998 20.44 21.9998 19.3333H22.6665C23.0332 19.3333 23.3332 19.0333 23.3332 18.6666V16.4466C23.3332 16.16 23.2398 15.88 23.0665 15.6466L21.5332 13.6C21.4065 13.4333 21.2065 13.3333 20.9998 13.3333ZM11.9998 20C11.6332 20 11.3332 19.7 11.3332 19.3333C11.3332 18.9666 11.6332 18.6666 11.9998 18.6666C12.3665 18.6666 12.6665 18.9666 12.6665 19.3333C12.6665 19.7 12.3665 20 11.9998 20ZM20.9998 14.3333L22.3065 16H19.3332V14.3333H20.9998ZM19.9998 20C19.6332 20 19.3332 19.7 19.3332 19.3333C19.3332 18.9666 19.6332 18.6666 19.9998 18.6666C20.3665 18.6666 20.6665 18.9666 20.6665 19.3333C20.6665 19.7 20.3665 20 19.9998 20Z" fill={color} />
      <defs>
        <linearGradient id={uniqueId} x1="16" y1="0" x2="16" y2="32" gradientUnits="userSpaceOnUse">
          <stop stopColor={radiosColor1} />
          <stop offset="0.885417" stopColor={radiosColor2} />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default CarrierIcon;
